/* Marinelie — Dunkelmodus-Schalter. Zustand in localStorage, frueh gesetzt
   durch das Inline-Skript in theme.liquid.

   Die alte Fassung schrieb den Zustand als textContent in den Knopf. Der
   Schalter im Footer hat aber Auszeichnung darin — Bahn und Griff — und
   die waere damit beim ersten Zeichnen weg gewesen. Jetzt setzt das
   Skript nur aria-checked am Knopf und schreibt das Wort in ein eigenes
   Feld daneben. */
(function () {
  'use strict';

  var WORT = { an: 'Dunkel', aus: 'Hell' };

  function an() {
    return document.documentElement.classList.contains('ml-dunkel');
  }

  function zeigen() {
    var zustand = an();
    document.querySelectorAll('[data-ml-dunkel]').forEach(function (knopf) {
      knopf.setAttribute('aria-checked', zustand ? 'true' : 'false');
    });
    document.querySelectorAll('[data-ml-dunkel-stand]').forEach(function (feld) {
      feld.textContent = zustand ? WORT.an : WORT.aus;
    });
  }

  function init() {
    var schalter = document.querySelectorAll('[data-ml-dunkel]');
    if (!schalter.length) return;
    zeigen();
    schalter.forEach(function (knopf) {
      knopf.addEventListener('click', function () {
        document.documentElement.classList.toggle('ml-dunkel');
        try {
          localStorage.setItem('ml_dunkel', an() ? '1' : '0');
        } catch (e) {
          /* Ohne Speicher bleibt der Modus fuer diese Seite bestehen. */
        }
        zeigen();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
